/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {GlobalGroupChooserDialog} from '@ion/dls/src/components/groupchooser/GlobalGroupChooserDialog';
import GlobalGroupsSearch from '@ion/features/src/global-groups/search';
import {useCurrentUser} from '@ion/query/src/hooks/useCurrentUser';
import {
  setGlobalGroup
} from '@/store/actions/global-group-chooser';

export interface GlobalGroupChooserMobile {
  toggleChangeGroup: Function;
}

/**
 * Display Account chooser for Mobile
 */
export const GlobalGroupChooserMobile = ({
  toggleChangeGroup
}: GlobalGroupChooserMobile) => {
  const dispatch   = useDispatch();
  const {username} = useCurrentUser().currentUser;
  const {
    accountHierarchy,
    globalGroup,
    groupChooser : {
      isViewing: openChooser
    }
  } = useSelector(({globalGroup}) => globalGroup);

  useEffect(function() {
    GlobalGroupsSearch.setAccounts(accountHierarchy);
  }, [accountHierarchy]);

  function onClose() {
    toggleChangeGroup?.();
  };

  function onSelectGroup(group) {
    dispatch(setGlobalGroup(group));
  };

  return (
    <GlobalGroupChooserDialog allCrumbsClickable
      open={openChooser}
      accountHierarchy={accountHierarchy}
      onClose={onClose}
      selectedGroup={globalGroup}
      onSelectGroup={onSelectGroup}
      userName={username}/>
  );
};

export default GlobalGroupChooserMobile;
